import React from 'react'

const Contact = () => {
  return (
    <div name='contact' className='w-full h-screen bg-[#0a192f] flex justify-center items-center p-4'>
        <form method='POST' action="https://getform.io/f/2fe74349-d45e-4781-97f4-4816883b57e6" className='flex flex-col max-w-[600px] w-full'>
            <div className='pb-8'>
                 <p className='text-4xl font-bold inline border-b-4  text-gray-300 border-green-600'>Contact </p> 
                
                <p className='text-gray-300 py-4' >Fill in the form below to send me a message or feedback</p>
            </div>
            <input className='bg-[#ccd6f6] p-2' type="text" placeholder='Name' name='name' />
            <input className='my-4 p-2 bg-[#ccd6f6]' type="email" placeholder='Email' name='email' />
            <textarea className='bg-[#ccd6f5] p-2' name="message" rows="10" placeholder='Message' ></textarea>
            <button className='text-white border-2 hover:bg-green-300 hover:border-black px-4 py-3 my-8 mx-auto flex items-center' >Contact Me!!</button>
        </form>

    </div>
  )
}

export default Contact